import { gsap } from 'gsap'

import Page from './../../classes/Page'

export default class extends Page {
  constructor () {
    super({
      id: 'contact',

      classes: {
        active: 'contact--active'
      },

      element: '#main',
      elements: {
        // contact: '.detail'
      }
    })
  }

  create () {
    super.create()
    
    console.log('create CONTACT page');

  }

  /**
  /**
   * Animations.
   */
  show () {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.25
    }

    this.isPopState = false
    this.timelineIn = new gsap.timeline()

    this.timelineIn.to(this.element, {
      duration: this.duration,
      autoAlpha: 1
    })

    return super.show(this.timelineIn)
  }

  hide () {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.5
    }
    
    this.timelineOut = new gsap.timeline()

    this.timelineOut.to(this.element, {
      duration: this.duration,
      autoAlpha: 0
    })

    this.timelineOut.call(() => {
      this.destroy()
    })

    return super.hide(this.timelineOut)
  }

  /**
   * Events.
   */
  // onTouchDown (event) {

  // }

  onPopState () {
    this.isPopState = true
  }
  
  /**
   * Destroy.
   */
  destroy () {
    super.destroy()
  }

}
